import { ProviderFilters } from "../../data-classes";
import { EntityBaseModel } from "./entity-base.model";

export class AdministratorModel extends EntityBaseModel {
  protected icon ={
    form: 'hotel',
    list: 'hotel'
  }

  setModelData(models:any) {
    models.administrator.icon = this.icon;

    models.administrator.form_tabData = {
      entity: models.administrator.entity,
      entity_type: models.administrator.entity_type,
      saveEndpoint: models.administrator.saveEndpoint,
      entity_permissions: models.administrator.permissions,
      entity_modules:models.administrator.modules,
      entity_label: models.administrator.labels.form,
      new_register_dropdowns: [],
      edit_register_dropdowns: []
    }

    models.administrator.list_tabData = {
      entity: models.administrator.entity,
      entity_type: models.administrator.entity_type,
      entity_label: models.administrator.labels.form,
      entity_permissions:models.administrator.permissions,
      entity_modules:models.administrator.modules,
      listParams: {
        list_entity: models.administrator.list_entity,
        list_label: models.administrator.labels.list,
        form_entity: 'administrator',
        limit: 10,
        headers: [
          'Activo',
          'CIF',
          'Nombre',
          'Teléfono',
          'Móvil',
          'Email',
        ],
        fields: [
          { entity: models.administrator.entity, field: 'enabled', type: 'check' },
          { entity: models.administrator.entity, field: 'cif' },
          { entity: models.administrator.entity, field: 'name' },
          { entity: models.administrator.entity, field: 'phone' },
          { entity: models.administrator.entity, field: 'mobile' },
          { entity: models.administrator.entity, field: 'email' },
        ],
        filter_firm: false,
        web_access: false,
        disable_user: false,
        filters: new ProviderFilters(models)
    }


    }
  }
}
